import { z } from "zod";

/**
 * Shape of the remote-feature manifest served by the API. This is the only
 * untrusted input in the registration path, so it is parsed rather than cast.
 */
export const remoteFeatureEntrySchema = z.object({
  id: z.string().min(1),
  remoteName: z
    .string()
    .min(1)
    // Federation remote names become JS identifiers in the generated container.
    .regex(/^[A-Za-z_$][\w$]*$/, "remoteName must be a valid JS identifier"),
  entry: z.url(),
  exposedModule: z.string().min(1).default("./module"),
  version: z.string().min(1).default("0.0.0"),
  enabled: z.boolean().default(true),
});

export const featureManifestSchema = z.object({
  modules: z.array(remoteFeatureEntrySchema).default([]),
});

export type RemoteFeatureEntry = z.infer<typeof remoteFeatureEntrySchema>;
export type FeatureManifest = z.infer<typeof featureManifestSchema>;
